/*
 *
 * SelfSignUp
 *
 * In-app self-serve sign-up has been retired. New customers get Movebooth from
 * the marketing product page, so this route forwards there. A visible link is
 * rendered as a fallback for the moment before the redirect fires (and for any
 * client where scripted navigation is blocked).
 *
 */

import React, { useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { MARKETING_SIGNUP_URL } from 'utils/marketing';
import { Wrapper, Heading } from './styledComponents';

const SelfSignUp = () => {
  useEffect(() => {
    window.location.replace(MARKETING_SIGNUP_URL);
  }, []);

  return (
    <Wrapper>
      <HelmetProvider>
        <Helmet title='Movebooth | Get Movebooth' />
      </HelmetProvider>
      <Heading>
        Taking you to Movebooth…{' '}
        <a href={MARKETING_SIGNUP_URL}>Continue to Movebooth</a>
      </Heading>
    </Wrapper>
  );
};

export default SelfSignUp;
